import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import ManagementHeader from './ManagementHeader';
import MgField from './MgField';
import { createFactory } from '../../services/api';
import { useTranslation } from '../../context/LanguageContext';
import './management.css';

function FactoryRegisterPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        code: '',
        location: '',
        address: '',
        manager: '',
        contact: '',
        email: '',
        description: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // API 형식에 맞게 데이터 변환
            const requestData = {
                factoryCode: formData.code,
                factoryName: formData.name,
                address: formData.address,
                latitude: null,
                longitude: null,
                managerName: formData.manager,
                managerPhone: formData.contact,
                managerEmail: formData.email,
                status: 'NORMAL', // 초기 상태는 항상 정상
                description: formData.description,
                lastInspectionDate: null
            };

            await createFactory(requestData);

            alert(t('pages.management.factoryRegister.alertSuccess'));
            navigate('/factory-list');
        } catch (err) {
            console.error('공장 등록 실패:', err);

            // 에러 메시지 상세 처리
            if (err.message.includes('already exists')) {
                alert(t('pages.management.factoryRegister.alertDuplicate'));
            } else {
                alert(t('pages.management.factoryRegister.alertFail'));
            }
        }
    };

    const L = (key) => t(`pages.management.factoryRegister.label.${key}`);
    const P = (key) => t(`pages.management.factoryRegister.placeholder.${key}`);
    const input = (name, type = 'text', required = true) => (
        <input type={type} name={name} className="mg-input" placeholder={P(name === 'manager' ? 'managerName' : name)} value={formData[name]} onChange={handleInputChange} required={required} />
    );

    return (
        <MainLayout>
            <div className="mg-page">
                <ManagementHeader crumbs={[{ label: t('sidebar.management.factoryRegister') }]} />

                <form className="mg-form" onSubmit={handleSubmit}>
                    {/* 기본 정보 */}
                    <div className="mg-panel">
                        <h3 className="mg-panel-title">{t('pages.management.factoryRegister.section.basic')}</h3>
                        <div className="mg-grid">
                            <MgField label={L('name')} required>{input('name')}</MgField>
                            <MgField label={L('code')} required>{input('code')}</MgField>
                            <MgField label={L('location')} required>{input('location')}</MgField>
                            <MgField label={L('address')} required>{input('address')}</MgField>
                        </div>
                    </div>

                    {/* 담당자 정보 */}
                    <div className="mg-panel">
                        <h3 className="mg-panel-title">{t('pages.management.factoryRegister.section.manager')}</h3>
                        <div className="mg-grid">
                            <MgField label={L('managerName')} required>{input('manager')}</MgField>
                            <MgField label={L('contact')} required>{input('contact', 'tel')}</MgField>
                            <MgField label={L('email')} required>{input('email', 'email')}</MgField>
                            <MgField label={L('description')} full>
                                <textarea name="description" className="mg-textarea" placeholder={P('description')} value={formData.description} onChange={handleInputChange} rows="4" />
                            </MgField>
                        </div>
                    </div>

                    <div className="mg-form-actions">
                        <button type="button" className="mg-btn secondary" onClick={() => navigate('/factory-list')}>
                            {t('pages.management.factoryRegister.btn.cancel')}
                        </button>
                        <button type="submit" className="mg-btn primary">
                            {t('pages.management.factoryRegister.btn.submit')}
                        </button>
                    </div>
                </form>
            </div>
        </MainLayout>
    );
}

export default FactoryRegisterPage;
